import React from 'react';
import { Globe, Check } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const LanguageSwitcher = () => {
    const { currentLanguage, changeLanguage } = useLanguage();

    const languages = [
        { code: 'en', name: 'English', flag: '🇺🇸' },
        { code: 'fr', name: 'Français', flag: '🇫🇷' },
        { code: 'de', name: 'Deutsch', flag: '🇩🇪' }
    ];

    return (
        <div className="relative group">
            <button className="flex items-center gap-2 px-3 py-2 bg-[#0d0d0d] border border-[#732424]/30 hover:border-[#d92323]/50 text-white rounded-lg transition-colors">
                <Globe className="w-4 h-4" />
                <span className="text-sm font-medium">
                    {languages.find(lang => lang.code === currentLanguage)?.flag}
                </span>
            </button>

            <div className="absolute top-full right-0 mt-2 w-48 bg-[#141414] border border-[#732424]/30 rounded-lg shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                {languages.map((language) => (
                    <button
                        key={language.code}
                        onClick={() => changeLanguage(language.code)}
                        className={`w-full flex items-center justify-between px-4 py-3 text-left hover:bg-[#1a1a1a] transition-colors first:rounded-t-lg last:rounded-b-lg ${currentLanguage === language.code ? 'text-[#d92323]' : 'text-white'
                            }`}
                    >
                        <div className="flex items-center gap-3">
                            <span className="text-lg">{language.flag}</span>
                            <span className="text-sm font-medium">{language.name}</span>
                        </div>
                        {currentLanguage === language.code && (
                            <Check className="w-4 h-4 text-[#d92323]" />
                        )}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default LanguageSwitcher;